
/**
 * GENERAL DIALOG FUNCTIONALITY
 */
import $ from 'jquery';

var dialogInitialised = new Set();

var numberOfOpenModals = 0;
var baseZIndex = 1000;
var backdropIncrement = 100;
var modalIncrement = 50;

var backdropTemplateSelector = '#dialog-backdrop-template';
var backdropSelectorPrefix = 'dialog-backdrop-';

export function setDialogInitialised( identifier ){
    dialogInitialised.add( identifier );
}

export function isDialogInitialised( identifier ){
    return dialogInitialised.has( identifier );
}

export function initDialog( dialogSelector, $openTrigger = null, $closeTrigger = null ){
    
    var $dialog = $( dialogSelector );
    $openTrigger = $openTrigger ? $( $openTrigger ) : null;
    $closeTrigger = $closeTrigger ? $( $closeTrigger ) : null;
    
    if ( !$dialog.length ){
        // TODOUI write error somewhere here?
        return false;
    }
    
    var $backdrop = $( backdropTemplateSelector ).clone();
    $backdrop.attr('id', backdropSelectorPrefix + $dialog.attr( 'id' ) );
    $backdrop.appendTo( $( 'body' ) );
    
    var dialogReusable = $dialog.attr( 'data-reusable' ) === "1";
    
    if ( dialogReusable  &&  isDialogInitialised( dialogSelector ) ) {
        return true;
    }
    
    if ( $openTrigger ){
        initDialogOpenTrigger( $dialog, $openTrigger );
    }
    
    /**
     * Standard Close Triggers
     */
    initDialogSelfClose( $dialog );
    initDialogCloseTrigger( $dialog, $dialog.find( ".dialog-close-button" ) );
    initDialogCloseTrigger( $dialog, $backdrop );
    
    /**
     * Additional close triggers
     */
    if ( $closeTrigger ){
        initDialogCloseTrigger( $dialog, $closeTrigger );
    }
    
    if ( dialogReusable ){
        setDialogInitialised( dialogSelector );
    }
    
}

export function initDialogOpenTrigger( $dialog, $openTrigger ){
    $dialog = $( $dialog );
    $openTrigger = $( $openTrigger );
    $openTrigger.on( 'click', function( event ) {
        showDialog( $dialog );
    });
}

function initDialogSelfClose( $dialog ){
    $dialog = $( $dialog );
    $dialog.on( 'click', function( event ) {
        /**
         * If the click is on the dialog only, not on any of its child content
         */
        if ( event.target === event.currentTarget ){
            hideDialog( $dialog );
        }
    });
}

export function initDialogCloseTrigger( $dialog, $closeTrigger ){
    $dialog = $( $dialog );
    $closeTrigger = $( $closeTrigger );
    $closeTrigger.on( 'click', function( event ) {
        hideDialog( $dialog );
    });
}

export function showDialog( $dialog ){
    
    numberOfOpenModals++;
    
    $dialog = $( $dialog );
    
    var $backdrop = getBackdropElement( $dialog );
    
    $backdrop.removeClass( 'hidden' );
    
    /**
     * calculate the backdrop z index by multiplying the num
     * of open modals by the 
     */      
    var newBackDropZIndex = baseZIndex + ( backdropIncrement * ( numberOfOpenModals ) );
    
    /**
     * Set the backdrop z index
     */
    $backdrop.css( "z-index", newBackDropZIndex );
    
    /**
     * Set the modal z-index
     */
    $dialog.css( "z-index", newBackDropZIndex + modalIncrement );
    
    $dialog.get(0).show();
}

export function hideDialog( $dialog ){
    
    numberOfOpenModals--;
    
    $dialog = $( $dialog );
    
    var $backdrop = getBackdropElement( $dialog );
    
    var dialogReusable = $dialog.attr( 'data-reusable' ) === "1";
    
    if ( dialogReusable ){
        $backdrop.addClass( 'hidden' );
    } else {
        $backdrop.remove();
    }
    
    
    $dialog.get(0).close();
}

function getBackdropElement( $dialog ){
    $dialog = $( $dialog );
    return $( '#' + backdropSelectorPrefix + $dialog.attr( 'id' ) );
}